/**
 * Copyright (C) 2020 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import { ChartType } from '../ChartSeriesItems';

/*
  This component creates an SVG symbol for a highcharts series based on the ChartType

  It applies the styles based on the classNames defined in <ChartsSeriesColorWrapper/>, which also wraps the Charts under
  the ChartsContainerWrapper

  - Lines are created for a Line Series (solid or dashes styles are defined in the <ChartsSeriesColorWrapper/>
  - A column is created for a Column Series
  - A Filled circle (highcharts default) are created for all other chart types
 */

export interface ChartCustomTooltipSymbolProps {
  chartType: ChartType;
  className: string;
}

const ChartCustomTooltipSymbol = (props: ChartCustomTooltipSymbolProps) => {
  const { chartType, className } = props;
  switch (chartType) {
    case ChartType.line:
      return (
        <svg width="21" height="16" style={{ position: 'absolute' }} display="inline-block">
          <path className={className} d="M0 8L21 8" />
        </svg>
      );
    case ChartType.xrange:
    case ChartType.column:
      return (
        <svg
          viewBox="0 0 21 8"
          width={21}
          height={8}
          style={{ display: 'inline-block', marginTop: '4px', position: 'absolute' }}
        >
          <rect className={className} width={21} height={8} />
        </svg>
      );
    case ChartType.area:
      return (
        <svg
          viewBox="0 0 21 8"
          width={21}
          height={8}
          style={{ display: 'inline-block', marginTop: '4px', position: 'absolute' }}
        >
          <rect className={className} width={21} height={1} />
          <rect className={className} style={{ opacity: 0.5 }} width={21} height={8} />
        </svg>
      );
    default:
      return (
        <svg
          viewBox="0 0 12 12"
          width={12}
          height={12}
          style={{ display: 'inline-block', marginTop: '5px', marginLeft: '5px', position: 'absolute' }}
        >
          <circle className={className} r={3} cx={6} cy={6} />
        </svg>
      );
  }
};

export default ChartCustomTooltipSymbol;
